<ts-panel
  [title]="financialReportVisualizationConfig?.title || panelDef?.title"
  [headerColor]="financialReportVisualizationConfig?.headerColor"
  [displayPanelOptions]="hasPanelData && canEditPanelDef"
  (panelOptionsClicked)="openPanelCreationDialog(financialReportVisualizationConfig)"
>
  @if (hasPanelData && financialReportVisualizationConfig?.reportPeriod) {
    <ts-badge
      ts-panel-title-side
      type="gray"
      [value]="reportPeriodLabels[financialReportVisualizationConfig.reportPeriod.key]"
    />
  }
  <div
    ts-panel-content
    class="flex flex-col justify-center items-center overflow-auto"
    [ngClass]="isOverviewTab ? 'h-100' : 'h-full'"
  >
    @if (hasPanelData) {
      <financial-statement-grid
        #financialStatementGrid
        [ngStyle]="{ zoom: '80%' }"
        [loading]="loading | async"
        [displayHeader]="false"
        [mode]="financialReportVisualizationConfig.type"
        [reportPeriod]="financialReportVisualizationConfig.reportPeriod"
        [financialStatement]="financialReportDataSource$ | async"
      />
    } @else {
      <ts-empty-state
        icon="ts_table"
        class="py-8"
        title="Create new Financial Report"
        [authorizeButton]="canEditPanelDef"
        [buttonConfig]="createNewFinancialReportConfig"
      ></ts-empty-state>
    }
  </div>
</ts-panel>
